import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, filter, map, take, tap } from 'rxjs';

export const authRequiredGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);

  // On hard reload, Auth0 may briefly report unauthenticated while it is still
  // restoring session state. Wait for isLoading$ to settle before deciding.
  return combineLatest([auth.isLoading$, auth.isAuthenticated$]).pipe(
    filter(([isLoading]) => !isLoading),
    take(1),
    tap(([, isAuthed]) => {
      if (isAuthed) return;
      auth
        .loginWithRedirect({
          appState: { target: state.url },
        })
        .subscribe();
    }),
    // If unauthenticated, we've initiated a redirect to Auth0 and should cancel
    // the current navigation (the browser is leaving the app).
    map(([, isAuthed]) => isAuthed),
  );
};

